/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon16Regular = forwardRef('ArrowDUturnRightUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M15.56 6.002a.75.75 0 0 1-1.12.996l-2.69-3.025V8.5a5.75 5.75 0 1 1-11.5 0V4.75a.75.75 0 0 1 1.5 0V8.5a4.25 4.25 0 1 0 8.5 0V3.973L7.56 6.998a.75.75 0 1 1-1.12-.996l3.252-3.66a1.75 1.75 0 0 1 2.616 0l3.253 3.66Z" })));
});
